/* nl-step-journey — one-screen-at-a-time story listicle behaviour.

   Root:        [data-nl-journey="<section id>"]  (attrs: data-nl-waste-prefix,
                data-nl-sale-chip, data-nl-event-step, data-nl-event-skip, data-nl-stop-word,
                data-nl-of-word, data-nl-dot-class, data-nl-done-class,
                data-nl-chip-waste-class, data-nl-chip-sale-class)
   Screens:     [data-nl-screen]   (attrs: data-nl-place, data-nl-waste = number | "sale",
                data-nl-next-label, data-nl-skip-target = "true" on a skip landing)
   Controls:    [data-nl-stop] [data-nl-chip] [data-nl-route] [data-nl-fill]
                [data-nl-plane] [data-nl-nav] [data-nl-back] [data-nl-next]
                [data-nl-next-text] [data-nl-skip]
   Overlay:     [data-nl-overlay] [data-nl-offer-open] [data-nl-overlay-close]
                [data-nl-qty] (data-nl-tile-note) [data-nl-variant] [data-nl-go]
                (data-nl-base = product url) [data-nl-note]
   Injected:    one <span data-nl-dot> per screen, inside the route.
   State:       screens carry nl-is-active; nav carries nl-is-first / nl-is-hidden.
   Modes:       always one visible screen, browser back/forward via #N hash
                states; in the theme editor no history is touched and selecting
                a block shows its screen.
   Lifecycle:   re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};

  function init(root) {
    if (!root || root.__nlJourney) return;
    var sectionId = root.getAttribute('data-nl-journey');
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cleanups = [];
    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }
    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return [].slice.call(root.querySelectorAll(sel)); }

    var screens = qa('[data-nl-screen]');
    var N = screens.length;
    if (!N) return;
    var cur = 0;
    var stop = q('[data-nl-stop]'), chip = q('[data-nl-chip]'), route = q('[data-nl-route]');
    var fill = q('[data-nl-fill]'), plane = q('[data-nl-plane]'), nav = q('[data-nl-nav]');
    var back = q('[data-nl-back]'), next = q('[data-nl-next]'), nextText = q('[data-nl-next-text]');
    var skip = q('[data-nl-skip]');
    var wastePrefix = root.getAttribute('data-nl-waste-prefix') || '';
    var saleChip = root.getAttribute('data-nl-sale-chip') || '';
    var evStep = root.getAttribute('data-nl-event-step');
    var evSkip = root.getAttribute('data-nl-event-skip');
    var stopWord = root.getAttribute('data-nl-stop-word') || 'Stop';
    var ofWord = root.getAttribute('data-nl-of-word') || 'of';
    var dotClass = root.getAttribute('data-nl-dot-class') || '';
    var doneClass = root.getAttribute('data-nl-done-class') || 'nl-is-done';
    var chipWaste = root.getAttribute('data-nl-chip-waste-class') || '';
    var chipSale = root.getAttribute('data-nl-chip-sale-class') || '';
    var dots = [];
    var shown = 0, anim = null;

    if (route && plane) {
      for (var i = 0; i < N; i++) {
        var d = document.createElement('span');
        d.className = dotClass;
        d.setAttribute('data-nl-dot', '');
        d.style.left = (N > 1 ? (i / (N - 1)) * 100 : 0) + '%';
        route.insertBefore(d, plane);
        dots.push(d);
      }
      cleanups.push(function () { dots.forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); }); });
    }

    function countTo(v) {
      clearInterval(anim);
      if (reduced) { shown = v; chip.textContent = wastePrefix + v; return; }
      var start = shown, t = 0;
      anim = setInterval(function () {
        t += 1;
        chip.textContent = wastePrefix + Math.round(start + (v - start) * Math.min(1, t / 18));
        if (t >= 18) { clearInterval(anim); shown = v; }
      }, 22);
    }

    function skipTarget(from) {
      for (var k = from + 1; k < N - 1; k++) {
        if (screens[k].getAttribute('data-nl-skip-target') === 'true') return k;
      }
      return N - 1;
    }

    function show(i, push, noScroll) {
      if (i < 0 || i >= N) return;
      screens[cur].classList.remove('nl-is-active');
      cur = i;
      var s = screens[cur];
      s.classList.add('nl-is-active');
      var pct = N > 1 ? (cur / (N - 1)) * 100 : 0;
      if (fill) fill.style.width = pct + '%';
      if (plane) plane.style.left = pct + '%';
      dots.forEach(function (x, k) { x.classList.toggle(doneClass, k <= cur); });
      if (stop) {
        stop.textContent = '';
        var b = document.createElement('b');
        b.textContent = String(cur + 1);
        stop.appendChild(document.createTextNode(stopWord + ' '));
        stop.appendChild(b);
        stop.appendChild(document.createTextNode(' ' + ofWord + ' ' + N + ' · ' + (s.getAttribute('data-nl-place') || '')));
      }
      if (chip) {
        var w = s.getAttribute('data-nl-waste');
        if (w === 'sale') {
          clearInterval(anim);
          chip.className = chipSale;
          chip.textContent = saleChip;
        } else {
          chip.className = chipWaste;
          countTo(parseInt(w, 10) || 0);
        }
      }
      if (nav) {
        nav.classList.toggle('nl-is-first', cur === 0);
        nav.classList.toggle('nl-is-hidden', cur === N - 1);
      }
      if (nextText) nextText.textContent = s.getAttribute('data-nl-next-label') || '';
      if (skip) skip.hidden = cur >= N - 2;
      if (!noScroll) window.scrollTo(0, 0);
      if (push !== false && !designMode) {
        try { history.pushState({ s: cur }, '', '#' + (cur + 1)); } catch (e) {}
      }
      if (evStep && window.dataLayer) window.dataLayer.push({ event: evStep, step: cur + 1 });
    }

    screens.forEach(function (s, k) { s.classList.toggle('nl-is-active', k === 0); });
    if (!designMode) { try { history.replaceState({ s: 0 }, '', '#1'); } catch (e) {} }
    show(0, false, true);

    on(next, 'click', function () { show(cur + 1); });
    on(back, 'click', function () { show(cur - 1); });
    on(skip, 'click', function () {
      var to = skipTarget(cur);
      if (evSkip && window.dataLayer) window.dataLayer.push({ event: evSkip, from: cur + 1, to: to + 1 });
      show(to);
    });
    on(window, 'popstate', function (e) {
      var s = e.state && typeof e.state.s === 'number' ? e.state.s : 0;
      show(s, false);
    });

    /* offer overlay */
    var ov = q('[data-nl-overlay]'), go = q('[data-nl-go]'), note = q('[data-nl-note]');
    var opener = null;
    var firstVariant = q('[data-nl-variant].nl-is-selected');
    var vid = firstVariant ? firstVariant.getAttribute('data-nl-variant') : '';
    function setGo() {
      if (!go) return;
      var base = go.getAttribute('data-nl-base');
      if (!base) return;
      go.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid);
      if (window.nlAdParams) window.nlAdParams.apply(go);
    }
    function openOv(e) {
      if (!ov) return;
      opener = e && e.currentTarget;
      ov.classList.add('nl-is-open');
      setGo();
      var sheet = q('[data-nl-sheet]');
      if (sheet) sheet.focus();
    }
    function closeOv() {
      if (!ov) return;
      ov.classList.remove('nl-is-open');
      if (opener && opener.focus) opener.focus();
    }
    qa('[data-nl-offer-open]').forEach(function (b) { on(b, 'click', openOv); });
    on(q('[data-nl-overlay-close]'), 'click', closeOv);
    on(ov, 'click', function (e) { if (e.target === ov) closeOv(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && ov && ov.classList.contains('nl-is-open')) closeOv();
    });
    var tiles = qa('[data-nl-qty]');
    tiles.forEach(function (t) {
      on(t, 'click', function () {
        tiles.forEach(function (x) { x.classList.remove('nl-is-selected'); x.setAttribute('aria-pressed', 'false'); });
        t.classList.add('nl-is-selected');
        t.setAttribute('aria-pressed', 'true');
        if (note) note.textContent = t.getAttribute('data-nl-tile-note') || '';
      });
    });
    var swatches = qa('[data-nl-variant]');
    swatches.forEach(function (b) {
      on(b, 'click', function () {
        swatches.forEach(function (x) { x.classList.remove('nl-is-selected'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('nl-is-selected');
        b.setAttribute('aria-pressed', 'true');
        vid = b.getAttribute('data-nl-variant');
        setGo();
      });
    });

    /* theme editor: selecting a block shows its screen */
    on(root, 'shopify:block:select', function (e) {
      var k = screens.indexOf(e.target.closest ? e.target.closest('[data-nl-screen]') : null);
      if (k > -1) show(k, false, true);
    });

    root.__nlJourney = true;
    instances[sectionId] = function () {
      clearInterval(anim);
      cleanups.forEach(function (fn) { fn(); });
      delete root.__nlJourney;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-journey]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-nl-journey]');
    if (!r) return;
    var id = r.getAttribute('data-nl-journey');
    if (instances[id]) { instances[id](); delete instances[id]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
